if (!customElements.get('custom-share-button')) {
  class CustomShareButton extends HTMLElement {
    constructor() {
      super();

      this.usesLegacyDOM = this.querySelector('details') !== null;

      if (!this.usesLegacyDOM) {
        // Shadow-based modern implementation
        this.attachShadow({ mode: 'open' });
        this.render();
      }
    }

    connectedCallback() {
      this.urlToShare = this.getAttribute('url') || window.location.href;

      if (this.usesLegacyDOM) {
        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };

        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : this.urlToShare;

        if (navigator.share) {
          this.querySelector('details').setAttribute('hidden', '');
          this.elements.shareButton?.classList.remove('hidden');
          this.elements.shareButton?.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else {
          this.querySelector('details')?.addEventListener('toggle', this.toggleDetails.bind(this));
          this.querySelector('.share-button__copy')?.addEventListener('click', this.copyToClipboard.bind(this));
          this.querySelector('.share-button__close')?.addEventListener('click', this.closeLegacy.bind(this));
        }
      } else {
        // Modern logic
        const button = this.shadowRoot.querySelector('button');
        const input = this.shadowRoot.querySelector('input');
        const success = this.shadowRoot.querySelector('.success-message');
        if (input) input.value = this.urlToShare;

        button.addEventListener('click', async (e) => {
          e.preventDefault();
          if (navigator.share) {
            try {
              await navigator.share({ url: this.urlToShare, title: document.title });
            } catch (err) {
              console.warn('Share failed:', err);
            }
          } else {
            try {
              await navigator.clipboard.writeText(this.urlToShare);
              success.classList.remove('hidden');
              success.textContent = window.accessibilityStrings?.shareSuccess || 'Link copied!';
            } catch (err) {
              console.error('Copy failed:', err);
            }
          }
        });
      }
    }

    toggleDetails() {
      if (!this.querySelector('details')?.open) {
        this.elements.successMessage?.classList.add('hidden');
        this.elements.successMessage.textContent = '';
        this.elements.closeButton?.classList.add('hidden');
        this.elements.shareSummary?.focus();
      }
    }

    copyToClipboard() {
      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        this.elements.successMessage?.classList.remove('hidden');
        this.elements.successMessage.textContent = window.accessibilityStrings?.shareSuccess || 'Copied!';
        this.elements.closeButton?.classList.remove('hidden');
        this.elements.closeButton?.focus();
      });
    }

    closeLegacy() {
      this.querySelector('details').removeAttribute('open');
    }

    render() {
      this.shadowRoot.innerHTML = `
        <style>
          button {
            all: unset;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
            font-size: 0.875rem;
            color: #5a5653;
          }
          .success-message {
            margin-left: 8px;
            font-size: 0.75rem;
            color: green;
          }
        </style>
        <div class="share-container">
          <button>
            <slot></slot>
          </button>
          <input type="hidden" value="">
          <span class="success-message hidden"></span>
        </div>
      `;
    }
  }

  customElements.define('custom-share-button', CustomShareButton);
}
